<template>
    <div
        v-for="option in configOptions"
        :key="option.name"
    >
        <ConfigOptionWithChildren
            v-if="option.is_parent_option === true"
            :contract="contract"
            :config-option="option"
            :is-domain-transfer="isDomainTransfer"
            @restartTransfer="handleRestartTransfer"
        />
        <ConfigOption
            v-else
            :contract="contract"
            :config-option="option"
            :is-domain-transfer="isDomainTransfer"
            @restartTransfer="handleRestartTransfer"
        />
    </div>
</template>

<script setup>

import { computed } from 'vue'
import ConfigOption from '~@/Components/Customers/Contracts/ConfigOption'
import ConfigOptionWithChildren from './ConfigOptionWithChildren.vue'

const props = defineProps({
    options: {
        type: Object,
        default: () => { return {} }
    },
    contract: {
        type: Object,
        default: () => { return {} }
    },
    isDomainTransfer: {
        type: Boolean,
        default: () => { return false }
    }
})

const emit = defineEmits(['restartTransfer'])

const configOptions = computed(() => {
    const parsedOptions = []

    // find all parent config values
    Object.keys(props.options).forEach(configName => {
        if (props.options[configName].is_parent_option === true) {
            const parentOption = props.options[configName]
            parentOption.children = []

            // find parent children and add them to parent config value object
            Object.keys(props.options).forEach(key => {
                if (props.options[key].parent_option === parentOption.name) {
                    parentOption.children.push(props.options[key])
                }
            })

            parsedOptions.push(parentOption)
            // if option is neither a parent or a child, add it normally to the list of options
        } else if (props.options[configName].is_parent_option === false && props.options[configName].parent_option === null) {
            parsedOptions.push(props.options[configName])
        }
    })

    return parsedOptions
})

const handleRestartTransfer = function () {
    emit('restartTransfer')
}

</script>

<style scoped>
</style>
